module.exports = __webpack_public_path__ + "img/swiper_introduce_02.9cfddc69.png";